import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../auth/auth.service';
import { GeneralRoutePaths } from '../enums/route-types.enum';
import { UserRole } from '../enums/user-role.enum';
import { ImpersonateService } from '../impersonate/impersonate.service';
import { UserInterface } from '../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard {
  private authService = inject(AuthService);
  private impersonateService = inject(ImpersonateService);
  private router = inject(Router);

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.impersonateService.impersonated()) {
      return true;
    }

    const user: UserInterface = this.authService.getUser();
    if (user?.role?.name === UserRole.ROLE_ADMIN) {
      return true;
    }

    this.router.navigate(['/', GeneralRoutePaths.FORBIDDEN]);

    return false;
  }
}
